import { makeStyles, shorthands } from '@fluentui/react-components';

export const useStyles = makeStyles({
  imagePreviewView: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    ...shorthands.margin('12px'),
    ...shorthands.gap('32px'),
    ...shorthands.flex(1),

    '& .image-preview-image-wrapper': {
      width: '598px',
      '& img': {
        width: '100%',
        height: 'auto',
      },
    },

    '& .image-preview-button-wrapper': {
      boxShadow: '0 0 2px rgba(0,0,0,0.12), 0 2px 4px rgba(0,0,0,0.14)',
      ...shorthands.borderRadius('6px'),
      ...shorthands.overflow('hidden'),

      '& .button-item': {
        ...shorthands.border('none'),
        ...shorthands.padding('12px'),
      },

      '& .button-config-wrapper': {
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: 'white',
        ...shorthands.padding('6px'),
        ...shorthands.borderRadius('8px'),
        ...shorthands.overflow('hidden'),

        '& .button-item': {
          ...shorthands.border('none'),
          ...shorthands.padding('6px', '12px'),
        },

        '& .button-divider': {
          width: '1px',
          backgroundColor: 'rgba(224, 224, 224, 1)',
          marginLeft: '4px',
          marginRight: '9px',
        },

        '& .cancel-button': {
          marginLeft: '5px',
        },
      },
    },

    '& .image-preview-notification-wrapper': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#FFFFFF',
      boxShadow: '0 0 2px rgba(0,0,0,0.12), 0 2px 4px rgba(0,0,0,0.14)',
      ...shorthands.gap('4px'),
      ...shorthands.borderRadius('6px'),
      ...shorthands.padding('12px'),
    },
  },
});
